<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid style="margin-top: 5%;">
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>Location: {{location}}</h3>
				</b-col>
				<b-col class="col-md-3 col-sm-6 col-xs-6 text-right">
					<span v-if="device.group_id!=6">
						<p v-if="$root.chkperm('page_devices','control')" class="p-1">												
								<span v-if="firstRecord.output_status==1">
									<!-- ON: {{row.item.output_status}} -->
									<toggle-button  :value="true" :name="device.imei_no" @change="onChangeEventHandler(device.imei_no,$event)" :sync="true" :labels="{checked: 'Light ON', unchecked: 'Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="80" :height="25" />
								</span>
								<span v-else >
									<!-- off:{{row.item.output_status}} -->
									<toggle-button :value="false" :name="device.imei_no" @change="onChangeEventHandler(device.imei_no,$event)" :sync="true" :labels="{checked: 'Light ON', unchecked: 'Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="80" :height="20" />

								</span>
						</p>
					</span>
					<!-- <span v-else>
						<p v-if="$root.chkperm('page_devices','control')" class="p-1">	
							<toggle-button  :value="row.item.amp_r>0?true:false" :name="row.item.imei_no" @change="onChangeEventPhaseHandler(row.item.imei_no,'R',$event)" :sync="true" :labels="{checked: 'R Light ON', unchecked: 'R Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="95" :height="25" />		
							
							<toggle-button  :value="row.item.amp_y>0?true:false" :name="row.item.imei_no" @change="onChangeEventPhaseHandler(row.item.imei_no,'Y',$event)" :sync="true" :labels="{checked: 'Y Light ON', unchecked: 'Y Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="95" :height="25" />

							<toggle-button  :value="row.item.amp_b>0?true:false" :name="row.item.imei_no" @change="onChangeEventPhaseHandler(row.item.imei_no,'B',$event)" :sync="true" :labels="{checked: 'B Light ON', unchecked: 'B Light OFF'}" :color="{checked: '#28a745', unchecked: '#dc3545'}" :width="95" :height="25" />
								
						</p>
					</span> -->
				</b-col>
				<b-col class="col-md-3 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill size="sm" class="mr-2"  @click="downloadPDF()">Download PDF</b-button>
					<b-button variant="dark" pill size="sm"  @click="downloadcsv()">Download CSV</b-button>
					
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div style="border-top: 3px solid #333; border-radius: 5px; min-height: 100px; background-color: #FFF; display: flex; flex-direction: column;">
						<b-row class="mt-4 px-3 mb-3">
							<b-col lg="6">
								<label class="mr-2">Show</label>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(output_status)="row">
										<b-badge pill variant="success" v-if="row.value == 1">ON</b-badge>
										<b-badge pill variant="danger" v-else>OFF</b-badge>
									</template>
									<template v-slot:cell(supply)="row">
										
										<img src="../assets/power-on.svg" v-if="row.value >0" style="max-width:20px; max-height:20px;">
										<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">
									</template>
									<template v-slot:cell(door_status)="row">
										<b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
										<b-badge pill variant="success" v-else>CLOSED</b-badge>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3 mb-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{(currentPage-1)*perPage}} to {{currentPage*perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="6">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import Header from "@/components/Header.vue";

import { ToggleButton } from 'vue-js-toggle-button'
export default {
	name: 'Devices Record',
	components: {
		"top-header": Header,
		ToggleButton
		
	},
	beforeDestroy(){
		//console.log("CLEAR INTERVAL DASHBOARD");	
		window.removeEventListener("scroll", this.onScroll, true)
	},
	sockets: {
        connect() {
			this.is_connected = 'Connected';
			console.log('socket connected');
        },
		commtoser_res(data){
			 data=JSON.parse(data);
			if(data.error==0){
				this.$bvToast.toast(data.message, {
					title: 'Light status',
					toaster: 'b-toaster-bottom-right', 
					autoHideDelay: 5000,
					variant: 'success',
					solid: true,
					appendToast: true
				});
			}else{
				this.$bvToast.toast(data.message, {
					title: 'Light status',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 5000,
					variant: 'warning',
					solid: true,
					appendToast: true
				});
			}
			//alert(data);
		},
        disconnect() {
			this.is_connected = 'Disconnected';
			console.log('socket disconnected')
		},
		datarecieved(data){
			console.log('ye le data');
			console.log(JSON.stringify(data));
		},

    },
	mounted(){
		this.initload();
	},
	data() {
		var self = this;
		return{
			email: '',
			password: '',
			url: self.$session.get('apiurl')+'indoreapi/device-record',
			imeino: self.$route.params.imeino,
			location: '',
			records: [],
			device: {},
			firstRecord:[],
			fields: [
				{ key: 'supply', label: 'Power', sortable: true, sortDirection: 'desc'},
				{ key: 'voltage_r', label: 'Volt.R',
					formatter: (value) => { 
						/*if(self.device.meter_type === '1P'){
							return value;
						}

						if(parseInt(value/100) <= 80){
							value = 0;
						}*/
						//alert(self.device.meter_type);
						return parseFloat(value).toFixed(1);
					},
				},
				{ key: 'voltage_y', label: 'Volt.Y',
					formatter: (value) => { 
						/*if(self.device.meter_type === '1P'){
							return '0.0';
						}
						if(parseInt(value/100) <= 80){
							value = 0;
						}*/
						return parseFloat(value).toFixed(1);
					},
				},

				{ key: 'voltage_b', label: 'Volt.B',
					formatter: (value) => {
						/*if(self.device.meter_type === '1P'){
							return '0.0';
						} 
						if(parseInt(value/100) <= 80){
							value = 0;
						}*/
						return parseFloat(value).toFixed(1);
					},
				},
				{ key: 'amp_r', label: 'Amp.R',
					formatter: (value, key, item) => { 
						/*if(self.device.meter_type === '1P'){
							return (value/100).toFixed(2);
						}
						if(item.output_status == 0 && parseInt(value/1000) < self.$root.correction_amp){
							value = 0;
						}*/
						if(parseInt(item.voltage_r) <= 80){
							value = 0;
						}
						return parseFloat(value).toFixed(1);
					},
				},
				{ key: 'amp_y', label: 'Amp.Y',
					formatter: (value, key, item) => { 
						if(item.output_status == 0 && parseInt(value) < self.$root.correction_amp){
							value = 0;
						}
						if(parseInt(item.voltage_y) <= 80){
							value = 0;
						}
						return parseFloat(value).toFixed(1);
					},
				},
				{ key: 'amp_b', label: 'Amp.B',
					formatter: (value, key, item) => { 
						if(item.output_status == 0 && parseInt(value) < self.$root.correction_amp){
							value = 0;
						}
						if(parseInt(item.voltage_b) <= 80){
							value = 0;
						}
						return parseFloat(value).toFixed(1);
					},
				},
				{ key: 'kw_r', label: 'KwR',
					formatter: (value, key, item) => { 
						/*if(self.device.meter_type === '1P'){
							return value;
						}
*/
						if(item.output_status == 0 && (parseInt(item.amp_r) < self.$root.correction_amp)){
							value = 0;
						}
						if(parseInt(item.voltage_r) <= 80){
							value = 0;
						}
						return parseFloat(value).toFixed(1);
					},
				},
				{ key: 'kw_y', label: 'KwY',
					formatter: (value, key, item) => { 
						if(item.output_status == 0 && (parseInt(item.amp_y) < self.$root.correction_amp)){
							value = 0;
						}
						if(parseInt(item.voltage_y) <= 80){
							value = 0;
						}
						return parseFloat(value).toFixed(1);
					},
				},
				{ key: 'kw_b', label: 'KwB',
					formatter: (value, key, item) => { 
						if(item.output_status == 0 && (parseInt(item.amp_b) < self.$root.correction_amp)){
							value = 0;
						}
						if(parseInt(item.voltage_b) <= 80){
							value = 0;
						}
						return parseFloat(value).toFixed(1);
					},
				},
				{ key: 'kwh', label: 'Kwh',
					formatter: (value) => { 
						return parseFloat(value).toFixed(2);
					},
				},
				{ key: 'total_kw', label: 'Total KW',
					formatter: (value, key, item) => { 
						
						if(item.output_status == 0 && (parseInt(item.amp_r) < self.$root.correction_amp && parseInt(item.amp_y) < self.$root.correction_amp && parseInt(item.amp_b) < self.$root.correction_amp)){
							value = 0;
						}
						return parseFloat(value).toFixed(2);
					},
				},
				{ key: 'update_time', label: 'TimeStamp',
					formatter: (value, key, item) => {
						var self = this;
						return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm:ss');
					}, 
				},
				{ key: 'output_status', label: 'Output', sortable: true },
				{ key: 'light_on', label: 'Light On', sortable: true },
				{ key: 'light_off', label: 'Light Off', sortable: true },
				/* { key: 'light_data', label: 'Thread', sortable: true ,
					formatter: (value) => {
						//var self = this;
						//console.log(key+'--'+item.update_time);
						if(value!=null && value!='null'){
							var lightData = JSON.parse(value);
							return lightData.thread; //self.$moment(item.update_time).format('DD-MM-YYYY HH:mm:ss');
						}else{
							return 0;
						}
					}, 
				}, */
				{ key: 'door_status', label: 'Door', sortable: true }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: []
		};
	},
	methods: {
		initload(){
			var self = this;
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key'),
				imeino: self.imeino
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.records;
					self.location = response.data.result.location;
					self.loading = false;
					self.totalRows = self.records.length;
					self.device = response.data.result.device;
					self.location = self.location+' | FP No:' +self.device.feeder_pillar_no;
					
					self.firstRecord =self.records[0];
					
					
					setTimeout(self.initload, self.$root.reload_duration);
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						var fieldData = row[field.key];
						//console.log('field.keyfield.key'+field.key);
						if(field.key =='light_data'){
							var value = row[field.key];
							var threadValue =0;
							if(value!=null && value!='null'){
								var lightData = JSON.parse(value);							
								threadValue =  lightData.thread; 
							}
							fieldData=threadValue;
						}

						if(field.key == 'output_status'){
						if(fieldData ==1){
							fieldData = "ON";
						}else{
							fieldData = "OFF";
						}
					}

					if(field.key == 'door_status'){
						if(fieldData ==1){
							fieldData = "OPEN";
						}else{
							fieldData = "CLOSED";
						}
					}



						dataarr.push(fieldData);
					}

					
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_data_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		},
		downloadPDF(){
			var self = this;

			var pdfMake = require('pdfmake/build/pdfmake.js');
			var pdfFonts = require('pdfmake/build/vfs_fonts.js');
			pdfMake.vfs = pdfFonts.pdfMake.vfs;

			var pdfdata = new Array();
			var data = new Array();
			var headerlength = 0;
			self.fields.forEach(element => {
				data.push(element.label);
				headerlength++;
			});

			var count = headerlength;
			pdfdata.push(data); 
			for(var i=0; i<self.records.length; i++){
				data = new Array();

				/* var output_status = self.records[i]['output_status'];
				var amp_r = self.records[i]['amp_r'];
				var amp_y = self.records[i]['amp_y'];
				var amp_b = self.records[i]['amp_b'];
				var kw_r = self.records[i]['kw_r']; */
				self.fields.forEach(element => {
					var value = self.records[i][element.key];

					if(element.key == 'total_kw'){
							value = (value/1).toFixed(3);
						}
						

						if(element.key =='light_data'){
						
							var threadValue =0;
							if(value!=null && value!='null'){
								var lightData = JSON.parse(value);							
								threadValue =  lightData.thread; 
							}
							value=threadValue;
						}

					if(element.key == 'output_status'){
						if(value ==1){
							value = "ON";
						}else{
							value = "OFF";
						}
					}

					if(element.key == 'door_status'){
						if(value ==1){
							value = "OPEN";
						}else{
							value = "CLOSED";
						}
					}



					data.push(value);
				});
				pdfdata.push(data);
			}
			var deviceid = self.imeino
			

			var d = new Date();
			var uniq = d.getFullYear()+'-'+d.getMonth()+'-'+d.getDate()+'-'+d.getTime();


			var fontsize = 14;
			var page = "landscape";
			var pagesize = "A4";
			if (count < 10) {
				fontsize = 14;
				 page = "portrait";
				pagesize = "A4";
			} else if (count < 15) {
				 fontsize = 10;
				page = "portrait";
				 pagesize = "A4";
			} else if (count > 15) {
				 fontsize = 14;
				page = "landscape";
				pagesize = "A3";
			}


			var docDefinition = {
				content: [
					{ text: 'Device Report : '+deviceid, style: 'heading' },
					{ text: ' ', style: 'heading' },
                   	{
						layout: 'lightHorizontalLines',
						table: {
							headerRows: 1,

							body: pdfdata
						}
					}
				],
				styles: {
					heading: {
						fontSize: 20,
						alignment: 'center',
						lineHeight: 1,
						bold: true
					},
                    subheading: {
                        fontSize: 14,
						alignment: 'center',
						lineHeight: 2,
						bold: false
                    }
				}, 
				defaultStyle: {
					fontSize: fontsize,
					bold: false
				},
				//pageOrientation: 'landscape',
				pageSize: pagesize,
       			pageOrientation: page
			};
			pdfMake.createPdf(docDefinition).download("REPORT_"+uniq+".pdf");
		},
		onChangeEventHandler(imei,event){
			let switchStatus = event.value;
			console.log('dev'+switchStatus);
			var o = new Object();
			var cmd ='ON';
			if(switchStatus==false){
				cmd = 'OFF';	
			}
			o.imei = imei;
			o.command = cmd;
			console.log('Send Cmd:'+JSON.stringify(o));			
			if(this.$socket.connected){
				console.log("CONNECTED AND LOADING DATA");
				
				this.$socket.emit('commtoser', o);
			}
			this.initload();
		},
		onChangeEventPhaseHandler(imei,phase,event){
			let switchStatus = event.value;
			console.log('dev'+switchStatus);
			var o = new Object();
			var cmd ='ON';
			if(switchStatus==false){
				cmd = 'OFF';	
			}
			o.imei 	= imei; 
			o.phase = phase; 
			o.command = cmd;
			console.log('Send Cmd:'+JSON.stringify(o));
			console.log('asdasd');
			if(this.$socket.connected){
				console.log("CONNECTED AND LOADING DATA");
				
				this.$socket.emit('commtoser_phase', o);
			}
			this.initload();
		},
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table td, .table th{
	vertical-align: middle;
}
</style>